import React, {useEffect, useState} from 'react';
import './BlackList.css';
import Translate, {t} from "../../../../../../../components/Translate";
import {deleteUserFromBlackList, getCompanyBlackList, getUserByPlatform} from "../../../../../../../services/company/api";
import {connect} from "react-redux";
import config from "../../../../../../../config";
import PropTypes from "prop-types";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../../../../services/chat/action";
import SelectedConversationHistory from "../../../history/ConversationHistory";
import PlatformIcon from "../../../../../../../components-new/general/PlatformIcon";
import TableAction from "../../../../../../../components-new/table/TableAction";
import DeleteIcon from "../../../../../../../assets/icons/DeleteIcon";
import ConfirmationModal from "../../../../../../../components-new/modals/ConfirmationModal";
import ChatMoreInfoModal from "../../../../../../../components-new/general/ChatMoreInfoModal";
import TableScroll from "../../../../../../../components-new/table/TableScroll";
import ForumIcon from "../../../../../../../assets/icons/ForumIcon";
import OperatorProfileDrawer from "../../../../../../../components-new/general/OperatorProfileDrawer";
import TableDateTime from "../../../../../../../components-new/table/TableDateTime";
import {hasManagementPermission} from "../../../../../../../utils/General";

function BlackList({
                       user,
                       client,
                       company,
                       addNotification,
                       loadOlderMessages,
                       selectConversation,
                       clearSelectedConversationFromStore,
                       conversation,
                   }) {

    const [blacklistedUsers, setBlacklistedUsers] = useState([]);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [isInnerModalOpen, setIsInnerModalOpen] = useState(false);
    const [selectedChat, setSelectedChat] = useState(null);
    const [operatorProfile, setOperatorProfile] = useState(null);
    const canViewOperatorProfile = user && user.authorities && hasManagementPermission(user);


    useEffect(() => {
        getCompanyBlackList(client.id).then(data => {
            setBlacklistedUsers(data)
        })
    }, [client.id]);

    const openConfirmationDialog = (user) => {
        setUserToDelete(user);
        setIsDialogOpen(true);
    };

    const closeConfirmationDialog = () => {
        setIsDialogOpen(false);
        setUserToDelete(null);
    };

    const confirmDelete = () => {
        setBlacklistedUsers(blacklistedUsers.filter(user => user.id !== userToDelete.id));
        closeConfirmationDialog();
        deleteUserFromBlackList(userToDelete.id, client.id)
        addNotification('userDeletedFromBlackList', config.notificationLevels.info);
    };

    const showConversationHistory = (conversationInfo) => {
        console.log(conversationInfo);
        selectConversation({
            id: conversationInfo.id,
            companyId: conversationInfo.companyId,
            platform: conversationInfo.platform,
            userFirstName: conversationInfo.user.firstName,
            userLastName: conversationInfo.user.lastName,
            userThumbUrl: conversationInfo.user.thumbUrl,
        });
    };

    const openOperatorProfile = (blacklistedUser) => {
        if (!canViewOperatorProfile || !blacklistedUser.operatorPlatformId) return;
        getUserByPlatform(blacklistedUser.operatorPlatformId)
            .then(operator => setOperatorProfile(operator))
            .catch(() => addNotification('somethingWentWrong', config.notificationLevels.error));
    };

    return (
        <div>
            <TableScroll className={'blacklist-block'} stickyActions>
                <table className="custom-table">
                    <thead>
                    <tr className="table-head">
                        <th style={{textAlign: 'center'}}><Translate text={'name'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'platform'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'subject'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'description'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'ip'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'blockedBy'}/></th>
                        <th style={{textAlign: 'center'}}><Translate text={'blockedAt'}/></th>
                        <th aria-label={t({text: 'actions', user})}/>
                    </tr>
                    </thead>
                    <tbody>
                    {blacklistedUsers.length === 0 && (
                        <tr className="table-no-result">
                            <td colSpan={8} className="blacklist-table__empty">
                                <Translate text="noResultsFound"/>
                            </td>
                        </tr>
                    )}
                    {blacklistedUsers.map(bl => (
                        <tr
                            className={'clickable-row'}
                            onClick={() => {
                                setIsInnerModalOpen(true);
                                setSelectedChat(bl.conversation);
                            }}
                            key={bl.id}
                        >
                            <td style={{textAlign: 'center'}}>{bl.userName}</td>
                            <td>
                                <div className="blacklist-platform-cell">
                                    <PlatformIcon conversation={bl.conversation} size={20}/>
                                    <span>
                                        {bl.conversation.platform.charAt(0).toUpperCase() +
                                            bl.conversation.platform.slice(1).toLowerCase()}
                                    </span>
                                </div>
                            </td>
                            <td style={{textAlign: 'center'}}>{bl.subject}</td>
                            <td style={{textAlign: 'center'}}>{bl.description}</td>
                            <td style={{textAlign: 'center'}}>{bl.userIp}</td>
                            <td style={{textAlign: 'center'}}>
                                {canViewOperatorProfile && bl.operatorPlatformId ? (
                                    <button
                                        type="button"
                                        className="blacklist-table__operator-button"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            openOperatorProfile(bl);
                                        }}
                                    >
                                        {bl.operatorName}
                                    </button>
                                ) : bl.operatorName}
                            </td>
                            <td style={{textAlign: 'center'}}>
                                <TableDateTime value={bl.createdAt}/>
                            </td>
                            <td style={{textAlign: 'center'}}>
                                <div className="table-actions">
                                    <TableAction
                                        tooltip={'chatHistory'}
                                        onClick={() => showConversationHistory(bl.conversation)}
                                        icon={<ForumIcon width={18} height={18}/>}
                                    />

                                    <TableAction
                                        tone="danger"
                                        tooltip={'remove'}
                                        onClick={() => openConfirmationDialog(bl)}
                                        icon={<DeleteIcon width={18} height={18} stroke="var(--ds-error-primary)"/>}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </TableScroll>


            {isDialogOpen &&
                <ConfirmationModal
                    variant="delete"
                    isOpen={isDialogOpen}
                    onClose={closeConfirmationDialog}
                    onConfirm={confirmDelete}
                    message={t({
                        text: 'areYouSureYouWantToProceed',
                        user
                    })}
                />
            }

            {conversation.id &&
                <SelectedConversationHistory
                    isOpen={Boolean(conversation.id)}
                    conversation={conversation}
                    user={user}
                    loadOlderMessages={loadOlderMessages}
                    closeWindow={clearSelectedConversationFromStore}
                    company={company}
                />
            }

            {isInnerModalOpen && selectedChat && (
                <ChatMoreInfoModal
                    isOpen={true}
                    onRequestClose={() => {
                        setIsInnerModalOpen(false);
                        setSelectedChat(null);
                    }}
                    company={selectedChat.companyInfo}
                    conversation={selectedChat}
                />
            )}

            {canViewOperatorProfile && (
                <OperatorProfileDrawer
                    open={!!operatorProfile}
                    onClose={() => setOperatorProfile(null)}
                    operator={operatorProfile}
                    parentCompanyId={company.id}
                    filters={{companyIds: [client.id]}}
                />
            )}
        </div>
    );
}

BlackList.propTypes = {
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
    company: state.company,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BlackList);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/blackList/BlackList.jsx